import { Component, OnInit } from '@angular/core';
import { SvgMorphingService } from 'src/app/services/svg-morphing.service';

@Component({
  selector: 'app-svg-load-morph-animation',
  templateUrl: './svg-load-morph-animation.component.html',
  styleUrls: ['./svg-load-morph-animation.component.scss']
})
export class SvgLoadMorphAnimationComponent {
  constructor(_svgMorphingService: SvgMorphingService) {
    setTimeout(() => {
      _svgMorphingService.startAnimation(1250);
    }, 750);
  }
}
